import {Component, OnInit, Output, EventEmitter, Inject} from 'ng-metadata/core';
import {LanguageSelectionService} from './languageSelection.service';
import {getAttributesMap, getVid, getRtlLanguages} from "../../../../appConfig/appConfigForward";
import {ChangeLangService} from "../../../../infra/lang/changeLang.service";
import {JwtUtilService} from "../../../../security/jwtUtil.service";
import {UserSessionManagerService} from "../../../../security/userSessionManager.service";
import {AnalyticsUtils} from "../../../../nddUtils/analyticsUtils.service";
const isEqual = require('lodash/isEqual');

@Component({
    selector: 'prm-language-selection',
    templateUrl: 'components/search/topbar/userArea/languageSelection/language-selection.html',
})

export class PrmLanguageSelection implements OnInit {

    @Output() private onCancel = new EventEmitter();
    @Output() private onSave = new EventEmitter();
    private languages: string[];
    private attributesMap = getAttributesMap();
    private _selectedLanguage: string;
    private vid = getVid();
    @Output() private changeLangEvent: EventEmitter<Object> = new EventEmitter();
    private rtlLanguages = getRtlLanguages();

    constructor(private languageSelectionService: LanguageSelectionService,
                private changeLangService: ChangeLangService,
                private jwtUtilService: JwtUtilService,
                @Inject('I18nService') private i18nService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private analyticsUtils: AnalyticsUtils
    ) {

        this.languages = this.attributesMap.interfaceLanguageOptions.split(',');
        this.selectedLanguage = i18nService.getLanguage();
        this.changeLangService.addLangParamToUrl(this.selectedLanguage);

    }

    ngOnInit() {
    }

    public close() {
        this.onCancel.emit(null);
    }

    public closeAfterSelectLang() {
        this.onSave.emit(null);
    }

    private changeLanguage(language) {
        if(!isEqual(language, this.selectedLanguage)) {
            this.sendAnalytics(language);
        }
        this.selectedLanguage = language;


        this.changeLangService.addLangParamToUrl(this.selectedLanguage);
        return this.i18nService.setLanguage(this.selectedLanguage).then(() => {
            this.changeLangEvent.emit({lang: this.selectedLanguage});
            // the timeout have been added to fix this: PRM-35152
            this.$timeout(() => {
                return this.$state.go(this.$state.current, {lang: this.selectedLanguage}, {reload: true});
            })
        });

    }

    private get selectedLanguage() {
        return this._selectedLanguage;
    }

    private set selectedLanguage(selectedLanguage) {
        this._selectedLanguage = selectedLanguage;
    }

    private successAction(response) {
        this.userSessionManagerService.syncJwtWithTabs(response.data);
        this.jwtUtilService.storeJwt(response.data);
    }

    public selectedLang(language) {
        let languageCode = 'mypref.language.option.' + language;
        return this.$translate.instant(languageCode);
    }

    private async sendAnalytics(language) {
        let payload = await this.getAnalyticsPayload(language);
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.CHANGE_LANGUAGE, payload);
    }

    private async getAnalyticsPayload(language: any) {
        const translation = await this.$translate("mypref.language.option." + language);
        return{
            'Language Type' : translation,
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/languageSelection/languageSelection.directive.ts